import React, { Component } from 'react';
import Button from '@mui/material/Button';
import { NavLink } from 'react-router-dom';
import Header from "../../header/header";
import logo from '../../../assets/images/celtech-title.png';

class NotAccess extends Component {

    render() {
        return (
            <React.Fragment>
                <Header />
                <div className="App-header" >
                    <img src={logo} className="App-img" alt="logo" />                   

                    <h1>Lo sentimos</h1>
                    <h3>No tiene los permisos necesarios para visitar esta pagina</h3>
                    <Button sx={{ mt: 1, mr: 1 }} type="submit" variant="outlined">
                        <NavLink className="color-white" to='/home' >
                            Ir al Inicio
                        </NavLink>
                    </Button>

                </div>
            </React.Fragment>
        )
    }
}

export default NotAccess;